import { Download } from "lucide-react";
import { Loader } from "@/components/shared/loader";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import type { ContentExportFormat } from "@/types/content";

interface ExportFormatMenuProps {
  isExporting?: boolean;
  onExport: (format: ContentExportFormat) => void;
  label?: string;
  className?: string;
}

export function ExportFormatMenu({
  isExporting,
  onExport,
  label = "تصدير",
  className,
}: ExportFormatMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={isExporting}
          className={cn("shrink-0", className)}
        >
          {isExporting ? (
            <Loader size="sm" />
          ) : (
            <Download />
          )}
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-44">
        <DropdownMenuItem onSelect={() => onExport("csv")}>
          تصدير CSV
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => onExport("xlsx")}>
          تصدير Excel
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
